/*
 * Dynoforce: maakt van de sticky balk op de productpagina een echte koopknop.
 *
 * Het thema levert daar een <button data-anchor="..."> die alleen naar het
 * koopblok scrolt. Op mobiel is dat de enige permanent zichtbare actie op de
 * pagina, dus die moet gewoon toevoegen aan de winkelwagen.
 *
 * Valt terug op het oude scrollgedrag als de balk, het formulier of de variant
 * ontbreekt, of als de gewone toevoegknop uitstaat (uitverkocht).
 */
(function () {
  var MOBIEL = '(max-width: 749.98px)';
  var KORT_LABEL = 'In winkelwagen';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Op 375px passen productnaam, prijs en "Aan winkelwagen toevoegen" niet
     naast elkaar. Op mobiel korten we het label in, op desktop blijft het staan. */
  function labelAanpassen(knop) {
    var spans = knop.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var span = spans[i];
      var tekst = (span.textContent || '').trim();
      if (!span.dataset.dfLabel && tekst.length > 3 && /winkelwagen|cart/i.test(tekst)) {
        span.dataset.dfLabel = tekst;
      }
      if (span.dataset.dfLabel) {
        span.textContent = window.matchMedia(MOBIEL).matches ? KORT_LABEL : span.dataset.dfLabel;
      }
    }
  }

  function init() {
    var bar = document.querySelector('.sticky-cta');
    if (!bar || bar.dataset.dfReady) return;

    var oudeKnop = bar.querySelector('button[data-anchor]');
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!oudeKnop || !form || bar.contains(form)) return;

    bar.dataset.dfReady = '1';

    // Klonen verwijdert de scroll-listener van het thema.
    var knop = oudeKnop.cloneNode(true);
    knop.removeAttribute('data-anchor');
    knop.setAttribute('type', 'button');
    knop.setAttribute('data-df-buy', '1');
    oudeKnop.parentNode.replaceChild(knop, oudeKnop);

    labelAanpassen(knop);
    if (window.matchMedia(MOBIEL).addEventListener) {
      window.matchMedia(MOBIEL).addEventListener('change', function () {
        labelAanpassen(knop);
      });
    }

    function scrollNaarKoopblok() {
      // Let op: form.id geeft het input-veld met name="id", niet het attribuut.
      var doel = form.closest('.product__info-container') || form;
      doel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    knop.addEventListener('click', function (e) {
      e.preventDefault();

      var idVeld = form.querySelector('[name="id"]');
      var variantId = idVeld && idVeld.value;
      var toevoegKnop = form.querySelector('[name="add"]');

      if (!variantId || (toevoegKnop && toevoegKnop.disabled)) {
        scrollNaarKoopblok();
        return;
      }

      knop.setAttribute('aria-busy', 'true');

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.ok ? r.json() : Promise.reject(r);
        })
        .then(function () {
          window.location.href = root() + 'cart';
        })
        .catch(function () {
          knop.removeAttribute('aria-busy');
          scrollNaarKoopblok();
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
